import React, { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import TrashIcon from 'components/icons/TrashIcon'
import CloseIcon from 'components/icons/CloseIcon'
import IconButton from 'components/Form/IconButton'

import './styles.scss'
import { getStaticImage } from 'utils/statics'
import composerActions from 'redux/actions/conversations/composerAct'

/**
 * AI suggestion button
 * @param {object} props
 * @param {[{ id: string, logId: string, content: string }]} props.suggestions
 * @param {boolean} props.isOpen
 * @param {string} props.conversationId
 * @param {() => boolean} props.onClick Display or hidden items responses
 * @param {function} props.onSelectItem Select an item from responses
 * @param {function} props.onRejectItem Reject an item from responses
 */
const AISuggestionButton = (props) => {
  const {
    suggestions = [], onClick, isOpen = false,
    onSelectItem, conversationId
  } = props

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(composerActions.getSuggestionsByUserId(conversationId))
  }, [conversationId])

  const onRejectItem = useCallback(
    (data) => {
      dispatch(composerActions.rejectSuggestion(conversationId, data))
    },
    [conversationId]
  )

  const size = suggestions.length
  const botImg = size > 0 ? 'robot-face-primary' : 'robot-face-grey'
  const btnEnabled = size > 0 ? '' : '-disabled'

  return (
    <div className='ai-suggestion_container'>
      <div
        title='Bot'
        className={`ai-suggestion_btn${btnEnabled}`}
        onClick={size > 0 && onClick ? () => onClick(true) : null}
      >
        <figure>
          <img src={getStaticImage(`/icons/orange-brand/${botImg}.svg`)} alt='Robot' />
        </figure>
      </div>
      {isOpen && size ? (
        <div className='ai-suggestion_items-container'>
          <div
            className='ai-suggestion_items-close-btn'
          >
            <IconButton
              onClick={() => onClick(false)}
            >
              <CloseIcon />
            </IconButton>
          </div>
          {
            suggestions.map((elem, idx) => {
              return (
                <div
                  key={elem.id || idx}
                  className='ai-suggestion_item'
                  onClick={(event) => {
                    event.stopPropagation()

                    onSelectItem(elem)
                  }}
                >
                  <div
                    className='ai-suggestion_item_reject-btn'
                  >
                    <IconButton
                      onClick={(event) => {
                        event.stopPropagation()

                        onRejectItem(elem)
                      }}
                    >
                      <TrashIcon />
                    </IconButton>
                  </div>
                  <div
                    className='ai-suggestion_item_text'
                    dangerouslySetInnerHTML={{ __html: elem.content }}
                  />
                </div>
              )
            })
          }
        </div>
      ) : null}
    </div>
  )
}

export default AISuggestionButton